document.addEventListener("DOMContentLoaded", function () {
  var targetElements = Array.from(document.querySelectorAll("p")).filter(
    (el) => el.innerText.trim() == '[blog-quiz-section]'
  );
  
  if (targetElements.length > 0) {
    var url = new URL(window.location.href);
    url.searchParams.set("view", "blog-section");
    fetch(url.toString())
      .then((response) => response.text())
      .then((data) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, "text/html");
        var newContent = doc.querySelector("[data-blog-section]");
        if (newContent) {
          targetElements.forEach((targetElement) => targetElement.replaceWith(newContent.cloneNode(true)));
        }
      })
      .catch((error) => console.error("Error fetching the content:", error));
  }
});
